"use strict";
exports.__esModule = true;
exports.ValidatedTextField = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var TextField_1 = require("./TextField");
function ValidatedTextField(props) {
    var onError = props.onError, onChange = props.onChange, validationRegEx = props.validationRegEx, value = props.value, variant = props.variant, rest = tslib_1.__rest(props, ["onError", "onChange", "validationRegEx", "value", "variant"]);
    var _a = react_1.useState(false), error = _a[0], setError = _a[1];
    var handleChange = function (event) {
        // is valid
        var isValid = validationRegEx.test(event.target.value);
        // show error if it does not match
        if (isValid) {
            setError(false);
            // fire the callback if any
            if (onError) {
                onError(false);
            }
        }
        else {
            setError(true);
            // fire the callback if any
            if (onError) {
                onError(true);
            }
        }
        // fire the callback for change
        if (onChange) {
            onChange(event);
        }
    };
    return (react_1["default"].createElement(TextField_1.TextField, tslib_1.__assign({}, rest, { error: error, onChange: handleChange, value: value, variant: variant })));
}
exports.ValidatedTextField = ValidatedTextField;
//# sourceMappingURL=ValidatedTextField.js.map